import { useEffect } from 'react';

const toJsonLd = (data) => JSON.stringify(data);

const ensureTrailingSlash = (url) => (url.endsWith('/') ? url : `${url}/`);

const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data || !id) {
      return undefined;
    }

    const scriptId = `jsonld-${id}`;
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = scriptId;
      document.head.appendChild(script);
    }

    script.text = toJsonLd(data);

    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) {
        existing.remove();
      }
    };
  }, [id, data]);

  return null;
};

export const getBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return ensureTrailingSlash(window.location.origin.replace(/\/$/, ''));
  }
  return 'https://wsklogistika.lt/';
};

export default JsonLd;
